/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/arrow-left-dark-no': {
    width: 9,
    height: 16,
    viewBox: '0 0 9 16',
    data: `
       <path d="M7.70068 14.7812L1.13468 8.21525C0.955184 8.03606 0.955184 7.74519 1.13468 7.566L7.70068 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    `
  }
})